<nb-card>
	<nb-card-body class="overflow-visible">
		@if (isFirstYearInitial(product)) {
			<initial-certification-dates [order]="order" [product]="product" [clientLogged]="clientLogged"></initial-certification-dates>
		}
		@if (isTransfer(product)) {
			<transfer-dates [order]="order" [product]="product"></transfer-dates>
		}
		@if (isRecertification(product) || (!isFirstYearInitial(product) && !isTransfer(product))) {
			<single-next-audit-date [order]="order" [product]="product"></single-next-audit-date>
		}
	</nb-card-body>
</nb-card>
